import {
  AnalyticsEvent,
  AnalyticsPlatform,
} from '../Context/AnalyticsProvider';
const Mixpanel = require('mixpanel-browser');

export interface MixpanelAnalyticsPlatformConfig {
  mixpanelProjectToken: string;
  isProduction: boolean;
}

export class MixpanelAnalyticsPlatform implements AnalyticsPlatform {
  constructor(config: MixpanelAnalyticsPlatformConfig) {
    // Not intialized statically because it requires env vars
    Mixpanel.init(config.mixpanelProjectToken, {
      debug: !config.isProduction,
      track_pageview: true,
      persistence: 'localStorage',
    });
  }

  getId() {
    return 'mixpanel';
  }
  isEventSupported(event: AnalyticsEvent) {
    return true;
  }
  identifyUser(userId: string, metadata?: any) {
    if (userId) Mixpanel.identify(userId);
    if (metadata) Mixpanel.register(metadata);
  }
  resetUser() {
    Mixpanel.reset();
    console.debug('Mixpanel reset');
  }
  async trackEvent(event: AnalyticsEvent, metadata?: any): Promise<void> {
    Mixpanel.track(event, metadata);
  }
}
